import { IBarighetsFilter } from "./IBarighetsFilter";

export class BarighetsFilter implements IBarighetsFilter {
    vag: number[];
    terrang: number[];
    orSearch: boolean;

    constructor() {
        this.vag = [];
        this.terrang = [];
        this.orSearch = undefined;
    }
}
